import Meta from 'vue-meta'

export const headMetaPlugin = Meta
